import {
  collection,
  getDocs,
  onSnapshot,
  query,
  where,
} from 'firebase/firestore';
import { firestoreOutFlax } from './firebase';

type Tprops = {
  args: any;
  pass: {
    arrRefStrings: string[];
    arrWhere: any;
    arrFuncs: any[];
  };
};

export const css1 =
  'color: green; background-color: black; font-size: 11px; padding: 2px 6px; border-radius: 3px';
export const css2 =
  'color: yellow; background-color: green; font-size: 10px; padding: 2px 6px; border-radius: 3px';

export const whereTool = async (props: Tprops) => {
  const { args, pass } = props;
  const { arrRefStrings, arrWhere, arrFuncs } = pass;

  const arrConds = [];
  const refColl = collection(firestoreOutFlax, ...arrRefStrings);

  const unsubscribes: (() => void)[] = [];

  arrWhere.forEach((capsCond: any) => {
    const resolve = capsCond();
    arrConds.push(resolve);

    const q = query(
      refColl,
      where(resolve.field, resolve.operator, resolve.value),
    );

    const unsub = onSnapshot(q, snapshot => {
      const arrDocs: any[] = [];
      const arrChanges: any[] = [];

      snapshot.forEach(doc => {
        arrDocs.push(doc.data());
      });

      snapshot.docChanges().forEach(change => {
        if (change.type === 'added') {
          console.log('Docs adicionadas:', change.doc.data());
        }
        if (change.type === 'modified') {
          console.log('Docs modificadas:', change.doc.data());
        }
        if (change.type === 'removed') {
          console.log('Docs removidas:', change.doc.data());
        }
        arrChanges.push(change.doc.data());
      });

      console.log('%cWhere Cond', css1, { arrConds });
      console.log('%cWhere Docs Found', css2, { arrDocs });
      console.log('%cChanges', css2, { arrChanges });

      for (const currFunc of arrFuncs) currFunc(arrDocs, args);
    });

    unsubscribes.push(unsub);
  });

  // Retorna função para cancelar todas as escutas
  return () => {
    unsubscribes.forEach(unsub => unsub());
  };
};
